export enum ShippingService {
  fedex = 'Fed Ex',
  ups = 'UPS',
  usps = 'USPS Postal Service',
  other = 'Other',
}
